import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

const UserThankyou = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="Thank you for Visiting" />
			<section className="thankyou">
				<div className="container">
					<div className="row">
						<div className="col-lg-5 mx-auto">
							<div className="text-center main-profile-content radius-20 p-4 position-relative">
								<h4 class="main-heading-font level-6 mt-3 mb-3">
									Dr. David Patel
								</h4>
								<h5 class="primary-medium-font level-8 extra-color-10">
									Sed ut perspiciatis unde omnis iste natus error sit voluptatem
									accusantium doloremque laudantium, totam rem aperiam, eaque
									ipsa quae ab illo inventore veritatis et quasi architecto
									beatae vitae dicta sunt explicabo.
								</h5>
								<div class="thankyou-btn edit-btn back position-absolute ">
									<Link href="/">
										<div class="nav-anchor">
											<i class="fa-solid fa-xmark"></i>
										</div>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default UserThankyou;
